export const AppRoutes = {
  // Login
  login: "/login",
  logout: "/logout",
  recover: "/recover",
  recoverSuccess: "/recover/success",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/reset-password/success",
  register: "/register",
  registerSuccess: "/register/success",
  authCallbackCognito: "/auth/callback/cognito",
  authCallback: "/auth/callback",
  loginVerify: "/login/verify",

  // Customer environment login (顧客環境ログイン)
  organizationSelect: "/session/organization-select",
  userSelect: "/session/user-select",
  userLoginVerify: "/session/user-login-verify",
  userFirstLogin: "/session/user-first-login",

  // Product SSO hand-off (every product redirect goes through this page)
  mintOauthRedirect: "/mint-oauth-redirect",

  // Home
  home: "/",

  // System Settings
  systemSettings: "/system-settings",
  systemSettingsAdminUsers: "/system-settings/admin-users",
  systemSettingsAdminUserCreate: "/system-settings/admin-users/create",
  systemSettingsAdminUserDetail: "/system-settings/admin-users/:id",
  systemSettingsAdminUserEdit: "/system-settings/admin-users/:id/edit",
  systemSettingsNotification: "/system-settings/notification",
  systemSettingsMaintenance: "/system-settings/maintenance",

  // Organization (CS機能)
  organizations: "/organizations",
  organizationCreate: "/organizations/create",
  organizationCreateSetup: "/organizations/:id/setup",
  organizationDetail: "/organizations/:id",
  organizationEdit: "/organizations/:id/edit",
  organizationUserCreate: "/organizations/:id/users/create",
  organizationUserEdit: "/organizations/:id/users/:userId/edit",

  // Master data
  masterData: "/master-data",
  masterDataDetail: "/master-data/:type",
  masterDataProductCreate: "/master-data/product/create",
  masterDataProductEdit: "/master-data/product/:productId/edit",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",
};

export const LoginRoutes = [AppRoutes.login];

export const DashboardRoutes = [AppRoutes.home];

export const HomeRoutes = [AppRoutes.home];

export const SystemSettingsRoutes = [
  AppRoutes.systemSettings,
  AppRoutes.systemSettingsAdminUsers,
  AppRoutes.systemSettingsAdminUserCreate,
  AppRoutes.systemSettingsAdminUserDetail,
  AppRoutes.systemSettingsAdminUserEdit,
  AppRoutes.systemSettingsNotification,
  AppRoutes.systemSettingsMaintenance,
];

export const OrganizationRoutes = [
  AppRoutes.organizations,
  AppRoutes.organizationCreate,
  AppRoutes.organizationCreateSetup,
  AppRoutes.organizationDetail,
  AppRoutes.organizationEdit,
  AppRoutes.organizationUserCreate,
  AppRoutes.organizationUserEdit,
];

export const MasterDataRoutes = [
  AppRoutes.masterData,
  AppRoutes.masterDataDetail,
  AppRoutes.masterDataProductCreate,
  AppRoutes.masterDataProductEdit,
];

export const AdminRoutes = [HomeRoutes].flat();
